import { DemoBookingModal } from "./demo-booking-modal"
import { useState } from "react"

const navLinks = [
  { label: "BridgeGate N8N node", href: "#bridgegate-n8n" },
  { label: "Measurable ROI", href: "#solutions" },
  { label: "Case Studies", href: "#case-studies" },
  { label: "Why Vorro", href: "#why-vorro" },
]

export function Footer() {
  const [demoModalOpen, setDemoModalOpen] = useState(false)

  return (
    <>
      <footer className="bg-[#f7f7f8] border-t border-[#e8e8ec]">
        <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8 py-12 lg:py-16">
          <div className="flex flex-col lg:flex-row lg:items-start lg:justify-between gap-8 lg:gap-16">
            {/* Logo and description */}
            <div className="max-w-sm">
              <a href="https://vorro.net" className="flex items-center">
                <img
                  src="https://vorro.net/logo/logo.webp"
                  alt="Vorro"
                  style={{ height: '32px', width: 'auto' }}
                />
              </a>
              <p className="mt-4 text-sm text-[#6b6b7b] leading-relaxed">
                Empowering enterprises with AI-powered data integration to move data and decisions faster.
              </p>
              <a 
                href="mailto:sales@vorro.net" 
                className="mt-4 inline-block text-sm text-[#9e3667] hover:text-[#843054] transition-colors font-medium"
              >
                sales@vorro.net
              </a>
            </div>

            {/* Navigation links */}
            <nav className="flex flex-wrap items-center gap-6 lg:gap-8">
              {navLinks.map((link) => (
                <a 
                  key={link.label}
                  href={link.href} 
                  className="text-sm text-[#6b6b7b] hover:text-[#2d2d3a] transition-colors"
                >
                  {link.label}
                </a>
              ))}
              <button
                onClick={() => setDemoModalOpen(true)}
                className="text-sm text-[#9e3667] hover:text-[#843054] transition-colors font-medium"
              >
                Get a Demo
              </button>
            </nav>
          </div>

          <div className="mt-12 pt-8 border-t border-[#e8e8ec] flex flex-col sm:flex-row items-center justify-between gap-4">
            <p className="text-sm text-[#6b6b7b]">
              © {new Date().getFullYear()} Vorro. All Rights Reserved.
            </p>
            <div className="flex items-center gap-6">
              <a href="#" className="text-sm text-[#6b6b7b] hover:text-[#2d2d3a] transition-colors">
                Privacy Policy
              </a>
              <a href="#" className="text-sm text-[#6b6b7b] hover:text-[#2d2d3a] transition-colors">
                Terms of Service
              </a>
            </div>
          </div>
        </div>
      </footer>

      <DemoBookingModal open={demoModalOpen} onOpenChange={setDemoModalOpen} />
    </>
  )
}
